import BaseView from '../../core/baseView';
import $ from 'jquery';

export default BaseView.extend({
  events: {
    'change input[name="payment[installment_afterpay_profile_no]"]':
      'showInstallmentDetail',
    'keyup #payment_installment_afterpay_iban': 'normalizeIbanField',
    'change #payment_installment_afterpay_iban': 'normalizeIbanField'
  },

  afterPayBLZUrl: 'https://cdn.afterpay.io/online-services/bank-lookup',

  normalizeIbanField(event) {
    const IBAN_REGEX = /^[a-zA-Z]{1,2}\d{0,20}$/;
    const $iban = $(event.target);
    const normalizedIban = $iban
      .val()
      .replace(/\s/, '')
      .toUpperCase();

    if (normalizedIban.length === 0) {
      this.model.set('iban', '');
    }

    if (IBAN_REGEX.test(normalizedIban) === true) {
      this.model.set('iban', normalizedIban);
    }

    const iban = this.model.get('iban');
    $iban.val(iban);
    this.calculateBankNumber(iban);
  },

  calculateBankNumber(iban) {
    const IBAN_REGEX = /^[A-Z]{2}\d{20}$/;

    if (IBAN_REGEX.test(iban) === false) return;

    const $submitButton = $('.payment_submit_button');
    const $inputWrapper = $('#payment_installment_afterpay_iban').closest(
      '.input-wrapper'
    );
    const $bic = $('#payment_installment_afterpay_bic');

    const country = iban.substr(0, 2).toUpperCase();
    let end = NaN;

    //check country logic
    switch (country) {
      case 'BE':
        //BEpp bbbk kkkk kkkk
        end = 2;
        break;
      case 'BG':
        //BGpp bbbb ssss ddkk kkkk kk
        end = 3;
        break;
      case 'DK':
        //DKpp bbbb kkkk kkkk kk
        end = 4;
        break;
      case 'DE':
        //DEpp bbbb bbbb kkkk kkkk kk
        end = 8;
        break;
      case 'EE':
        //EEpp bbkk kkkk kkkk kkkk
        end = 2;
        break;
      case 'FI':
        //FIpp bbbb bbkk kkkk kP
        end = 6;
        break;
      case 'FR':
        //FRpp bbbb bsss sskk kkkk kkkk kPP
        end = 5;
        break;
      case 'GR':
        //GRpp bbb bbbb kkkk kkkk kkkk kkkk
        end = 7;
        break;
      case 'IE':
        //IEpp bbbb ssss sskk kkkk kkkk
        end = 4;
        break;
      case 'IS':
        //ISpp bbbb kkkk kkkk xxxx xxxx xx
        end = 4;
        break;
      case 'IT':
        //ITpp xxxx xxxx xxxx xxxx xxxxx xxx
        end = 0;
        break;
    }

    if (isNaN(end)) return;

    //cut of bank number
    const blz = iban.substr(4, end);

    $.ajax({
      url: `${this.afterPayBLZUrl}/${country}/${blz}`,
      type: 'GET',
      beforeSend() {
        $inputWrapper.prepend(
          $('<span class="svg-preloader js-remote-validation"></span>')
        );
        $submitButton.prop('disabled', true);
      },
      complete({ responseJSON }) {
        if (Boolean(responseJSON.bic)) {
          $bic.val(responseJSON.bic);
        }
        $('.js-remote-validation').remove();
        $submitButton.prop('disabled', false);
      }
    });
  },

  showInstallmentDetail(event) {
    const profileNo = event.target.value;

    this.$el
      .find('.js-payment-installment-afterpay-detail')
      .addClass('is-hidden')
      .filter(`[data-installment-afterpay-profile-no="${profileNo}"]`)
      .removeClass('is-hidden');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentInstallmentAfterPayView.js
 **/